import React from 'react';
import { useNavigate } from 'react-router-dom';
import FormActions from '@/components/shared/FormActions';

interface EstimateFormActionsProps {
  isLoading: boolean;
  isEditMode: boolean;
}

const EstimateFormActions: React.FC<EstimateFormActionsProps> = ({ isLoading, isEditMode }) => {
  const navigate = useNavigate();

  return (
    <FormActions
      onCancel={() => navigate('/estimates')}
      isSubmitting={isLoading}
      submitLabel={isEditMode ? 'Update & Continue' : 'Create & Continue'}
      submittingLabel="Saving..."
    />
  );
};

export default EstimateFormActions;
